/**
 * Created by lakshan on 6/6/17.
 */
(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name messageAdmin.service:MessageAdminService
	 *
	 * @description
	 *
	 */
	angular.module('greatCircleDistance').service('GreatCircleDistanceService', GreatCircleDistanceService);

	function GreatCircleDistanceService(RemoteService, GreatCircleDistanceFactory, EventManagerService) {

		var self = this;

		self.searchGridCircularDistance = function(searchParam, successFn, errorFn) {
			var requestParam = GreatCircleDistanceFactory.searchDistanceRQ(searchParam);
			RemoteService.searchGridCircularDistance.call(this, requestParam).then(
				function (response) {
					successFn(response);
				},
				function (error) {
					errorFn(error);
				}
			);
		}

		self.saveGridCircularDistance = function (request, successFn, errorFn) {
			var requestParam = request;
			var isUpdate = true;
			if(angular.isUndefined(request.gridCircleId)) {
				requestParam = GreatCircleDistanceFactory.saveDistanceRQ(request);
				isUpdate = false;
			}
			RemoteService.saveGridCircularDistance.call(this, requestParam).then(
				function (response) {
					if(response.success) {
						if(isUpdate) {
							EventManagerService.notifyEventListeners(EventManagerService.EVENT.DO_REFRESH, {action : "EDIT", param : requestParam});
						} else {
							EventManagerService.notifyEventListeners(EventManagerService.EVENT.DO_REFRESH, {action : "ADD", param : requestParam});
						}
					}
					successFn(response);
				},
				function (error) {
					errorFn(error);
				}
			);	   
		}

		self.deleteGridCircularDistance = function (requestParam, successFn, errorFn) {
			RemoteService.deleteGridCircularDistance.call(this, requestParam).then(
				function (response) {
					if(response.success) {
						EventManagerService.notifyEventListeners(EventManagerService.EVENT.DO_REFRESH, {action : "DELETE", param : requestParam});
					}
					successFn(response);
				},
				function (error) {
					errorFn(error);
				}
			);	   
		}

		self.appendToGridDistanceList = function (existingGridDistanceData, newGridDistanceData) {
			angular.forEach(newGridDistanceData.gridDistanceList, function (distanceObj) {
				var foundDistanceIndex = _.findIndex(existingGridDistanceData.gridDistanceList, {gridCircleId: distanceObj.gridCircleId})
				if (foundDistanceIndex >= 0) {
					existingGridDistanceData.gridDistanceList.splice(foundDistanceIndex, 1, distanceObj);
				} else {
					existingGridDistanceData.gridDistanceList.push(distanceObj);
				}
			});
		};

	}
})();
